// extracted by mini-css-extract-plugin
export default {"popupContainer":"style_popupContainer__fOLX5","popupInnerBox":"style_popupInnerBox__s9CoM","closePopup":"style_closePopup__7zgLF","errorTxt":"style_errorTxt__wsvcq"};